'use client'

import { trackClick } from '@/lib/mixpanel'

export default function TrackedLinkButton(props) {
  return (
    <button
      {...props}
      onClick={(e) => {
        trackClick(e, props.trackingdata)
        if (props.href) window.location.assign(props.href)
      }}
    >
      {props.children}
    </button>
  )
}
